import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as RegisterActionCreators from '../../actions/actions';
import { AlertForm, FormInput, FormWrapper, FormButton, FormCheckBox, FormCardGroup } from '../Helpers/Form';
import './Register.css';

const Register = function (props) {
  const {
    registerVm, register, registerChange, history
  } = props;
  const {
    email, password, acceptAGBs
  } = registerVm;
  return (
    <div className="register">
      <h1>Registrieren</h1>
      <AlertForm onSubmit={() => register(registerVm, history)} onChange={({ name, value }) => registerChange(name, value)} >
        <FormInput name="email" text="E-Mail" type="email" value={email} />
        <FormInput text="Passwort" type="password" value={password} name="password" />
        <FormWrapper type="link">
          <div>Ich habe die <Link to="/agb">AGB</Link> gelesen und akzeptiere sie.</div>
          <FormCardGroup type="card" text=" ">
            <FormCheckBox
              name="acceptAGBs"
              text="Ja"
              value="acceptAGBs"
              checked={acceptAGBs.has('acceptAGBs')}
            />
          </FormCardGroup>
        </FormWrapper>
        <FormButton text="Registrieren" disabled={!acceptAGBs.has('acceptAGBs')} />
      </AlertForm>
    </div>
  );
};

export default connect(
  state => ({
    ...state.registerReducer, ...state.alertReducer
  }),
  dispatch => bindActionCreators(RegisterActionCreators, dispatch)
)(withRouter(Register));



// WEBPACK FOOTER //
// ./src/pages/Register/index.js